import { flatMap } from 'lodash';

export const computeAccessories = config =>
  flatMap(config.accessories, x => x.options).filter(x => x.selected);
